import React, {useEffect, useRef, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import PlayListTable from '../../../trigger/components/PlayListTable'
import {apiSetValidationRole} from '../../../../redux/api'

type Props = {
  showValidationModal: boolean
  onClose: () => void
  configuration: any
  playLists: any
  resetConfiguration: any
  configurationId: any
}

function SetValidationModal({
  showValidationModal,
  onClose,
  configuration,
  playLists,
  resetConfiguration,
  configurationId,
}: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const handleConfirm = () => {
    if (!configuration?.ConfigurationPlaylistLinkId) return

    const requestBody = {
      ConfigurationPlaylistLinkId: configuration?.ConfigurationPlaylistLinkId,
    }

    setIsLoading(true)
    setError(null)

    apiSetValidationRole(configurationId, requestBody)
      .then(({data}: any) => {
        if (!isMounted.current) return
        if (data?.Status === 200) {
          onClose()
          resetConfiguration()
        } else {
          setError(data?.Message || 'Failed to set validation')
        }
      })
      .catch((err: any) => {
        if (!isMounted.current) return

        setError(err?.response?.data?.Message || 'Something went wrong')
      })
      .finally(() => {
        if (!isMounted.current) return

        setIsLoading(false)
      })
  }

  return (
    <Modal show={showValidationModal} onHide={onClose} centered size='lg'>
      <Modal.Body>
        <h1 className='text-primary mb-5'>Set Validation Playlist</h1>

        <p>You have selected the following playlist as validation playlist:</p>

        <div className='mb-8'>
          {configuration && (
            <PlayListTable
              playLists={[playLists]}
              ShowCommandInfo={{
                Playlists: [
                  {
                    PlaylistId: playLists?.Id,
                  },
                ],
              }}
            />
          )}
        </div>

        <p>This playlist will be shown when a customer uses the Validation feature.</p>
        <p>This change will be immediate once you confirm below.</p>

        {error && <p className='text-danger mt-2'>{error}</p>}

        <div className='d-flex gap-5 mt-7'>
          <Button variant='primary' size='sm' onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? 'Confirming...' : 'Confirm'}
          </Button>
          <Button variant='secondary' size='sm' onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SetValidationModal
